import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-modal" }

import { useI18n } from "vue-i18n";
import type messages from '@/i18n/frFR' 

type ImagingI18nKey = keyof typeof messages['patient']['document']['imaging']

interface ImagingItem {
  menuKey: ImagingI18nKey
  titleKey: ImagingI18nKey
  type: 'ImagingRequest' | 'PetScanRequest'
}


export default /*@__PURE__*/_defineComponent({
  __name: 'addImaging',
  emits: ["prescribeImaging"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const emits = __emit;

function prescribeImaging(internalCode: string, documentOriginalText: string) {
  emits('prescribeImaging', internalCode, documentOriginalText)
}

const imagingList: ImagingItem[] = [
  { menuKey: 'rxShort', titleKey: 'rxShort', type: 'ImagingRequest' },
  { menuKey: 'usShort', titleKey: 'usShort', type: 'ImagingRequest' },
  { menuKey: 'ct',      titleKey: 'ct',      type: 'ImagingRequest' },
  { menuKey: 'mrt',     titleKey: 'mrt',     type: 'ImagingRequest' },
  { menuKey: 'petScan', titleKey: 'petScan', type: 'PetScanRequest' },
  { menuKey: 'general', titleKey: 'other',   type: 'ImagingRequest' },
];


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_dbGroup = _resolveComponent("dbGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_dbGroup, null, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(imagingList, (imaging) => {
          return _createVNode(_component_list_group, {
            key: imaging.menuKey,
            styles: "pad-s",
            onClick: ($event: any) => (prescribeImaging(imaging.type, _unref(t)(`patient.document.imaging.${imaging.menuKey}`)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: _unref(t)(`patient.document.imaging.${imaging.titleKey}`)
              }, null, 8, ["txt"])
            ]),
            _: 2
          }, 1032, ["onClick"])
        }), 64))
      ]),
      _: 1
    })
  ]))
}
}

})